import { render } from "./StockAdjustmentReasons.vue?vue&type=template&id=23a3531c"
import script from "./StockAdjustmentReasons.vue?vue&type=script&lang=js"
export * from "./StockAdjustmentReasons.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/Accounting/StockAdjustmentReasons.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "23a3531c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('23a3531c', __exports__)) {
    api.reload('23a3531c', __exports__)
  }
  
  module.hot.accept("./StockAdjustmentReasons.vue?vue&type=template&id=23a3531c", () => {
    api.rerender('23a3531c', render)
  })

}


export default __exports__